// Stoneheim web client entry — connect, route vsj.screen to the right screen,
// pump patches + fx. The frontend just displays what the driver tells it.

import * as net from './net';
import * as vsj from './vsj';
import * as fx from './fx';
import * as sfx from './audio/sfx';
import * as music from './audio/music';
import { el, onDenyAlert } from './kit';
import { applySavedTheme, applySavedMotion } from './components/settings';
import { installInteractions } from './interact';
import { loginScreen } from './screens/login';
import { charSelectScreen } from './screens/char_select';
import { worldScreen } from './screens/world';

applySavedTheme();
applySavedMotion();
installInteractions(); // press spark + deny hit-test + non-button voices
sfx.init();
music.init();
// one line routes every audible game moment into the palette
fx.onFxType('*', (f) => sfx.onFx(f as Record<string, unknown>));

const app = document.getElementById('app')!;
let currentScreen = '';
let screenHandle: { root: HTMLElement; onVsj(changed: Set<string>): void } | null = null;

const statusLine = el('div', {
  style:
    'position:fixed;top:0;left:50%;transform:translateX(-50%);z-index:110;padding:3px 12px;' +
    'background:var(--bg-modal);border:1px solid var(--border);border-top:none;' +
    'border-radius:0 0 4px 4px;font-size:var(--font-small);color:var(--text-dim);display:none',
});
document.body.append(statusLine);
net.onStatus((s) => {
  statusLine.textContent = s;
  statusLine.style.display = s ? 'block' : 'none';
});

function mount(screen: string): void {
  currentScreen = screen;
  app.replaceChildren();
  document.getElementById('overlays')!.replaceChildren();
  switch (screen) {
    case 'char_select':
      screenHandle = charSelectScreen();
      break;
    case 'world':
      screenHandle = worldScreen();
      break;
    default:
      screenHandle = loginScreen();
  }
  app.append(screenHandle.root);
}

vsj.onChange((changed) => {
  const screen = String(vsj.at('screen') ?? 'login');
  if (screen !== currentScreen || !screenHandle) mount(screen);
  else screenHandle.onVsj(changed);
});

net.onFx((list) => fx.handleFx(list));
onDenyAlert((text) => fx.alert(text));

mount('login');
net.connect();
